import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">主题索引</h2>
          <p className="text-sm md:text-base text-foreground-400">按分类浏览国产吃瓜内容，快速找到你感兴趣的主题</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group rounded-xl bg-background-50 border border-background-200/60 p-5 md:p-6 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-1.5 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 line-clamp-2 mb-3">{item.desc}</p>
              <span className="text-xs font-medium text-primary-500">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}